// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/components/realtorauto/RealtorAutoExplanationDirectCheckPanel.tsx
// Source SHA-256: c16dd2cabb705b0e488d7512751703aa2524f406a8b72946a75463cf6c981a78
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
'use client';

import { memo } from 'react';
function RealtorAutoExplanationDirectCheckPanelComponent({
  visible,
  count,
  children
}) {
  if (!visible) return null;
  return <div className="rounded-lg border border-amber-300 bg-amber-50 p-4" data-explanation-direct-confirmation-panel>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-sm font-black text-amber-950">직접확인 필요 체크박스</div>
          <p className="mt-1 text-xs leading-5 text-amber-800">
            API로 확정되지 않은 항목입니다. 한 번 이상 직접 체크하고 저장하면 일반 체크값과 동일하게 취급됩니다.
          </p>
        </div>
        <span className="rounded-full bg-white px-2 py-1 text-[11px] font-black text-amber-700">{count}건</span>
      </div>
      <div className="mt-3 grid gap-2 md:grid-cols-2">{children}</div>
    </div>;
}
export const RealtorAutoExplanationDirectCheckPanel = memo(RealtorAutoExplanationDirectCheckPanelComponent);
